import { useEffect, useState } from 'react';

const DEBOUNCE_DELAY = 1000;

function useDebouncedValue(value: any, delay = DEBOUNCE_DELAY) {
  const [valueDebounced, setValueDebounced] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setValueDebounced(value), delay);
    return () => clearTimeout(timeout);
  }, [value, delay]);

  return [valueDebounced, setValueDebounced];
}

export default useDebouncedValue;
